var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide_data"},[_c('div',{staticClass:"personal-bottom-bottom-left"},[_c('div',{staticClass:"publicvideos",on:{"click":_vm.navpublicvideo}},[_c('span',[_vm._v("发布")])]),_vm._v(" "),_c('slide',{attrs:{"slideItem":_vm.slideItem},on:{"change":_vm.change}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8cdf64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/template/centerAside.vue
// module id = null
// module chunks = 